import { Box, Stack, Typography } from "@mui/material";

const IncidentTimeline = ({ items = [] }) => (
  <Stack spacing={1.25}>
    {items.map((item, index) => (
      <Box key={`${item.time}-${item.label}`} display="grid" gridTemplateColumns="58px 1fr" gap={1.5}>
        <Typography variant="caption" color="text.secondary" sx={{ fontFamily: (theme) => theme.custom.monoFont }}>{item.time}</Typography>
        <Box sx={{ position: "relative", pl: 2, pb: 1.5, borderLeft: index === items.length - 1 ? "1px solid transparent" : "1px solid", borderColor: "divider" }}>
          <Box sx={{ position: "absolute", left: -5, top: 3, width: 9, height: 9, borderRadius: "50%", bgcolor: "primary.main" }} />
          <Typography fontWeight={600}>{item.label}</Typography>
          <Typography variant="caption" color="text.secondary">{item.camera} · {Math.round(Number(item.confidence || 0) * 100)}% confidence</Typography>
        </Box>
      </Box>
    ))}
  </Stack>
);

export default IncidentTimeline;
